module.exports = __webpack_public_path__ + "static/media/loading.aa234cd2.gif";